export default __webpack_public_path__ + "static/es-ab57bf70f93a708e0107e83d3baf07f3.svg";